
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the Employee Report search filter component
------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import '../../ReportsCommonStyles/CommonSearchFilterStyle.css';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import { get_worksite_with_out_pagination } from '../../../../config/Worksite/siteApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_technology_with_out_pagination } from '../../../../config/Resource/technologyApis';
import ActionButtonWithIcon from '../../../../Components/custom_components/CustomButtons/ActionButtonWithIcon/ActionBtnWithIcon';
import { Icons } from '../../../../utils/GlobalIcons';
import { monthOptions, yearOptions } from '../../../../utils/formatDate';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';

function WorksiteReportFilter({
  tableTitle,
  searchFilter, on_change_value, on_page_count_update,
  onExportPDF,
  onExportExcel,
  isExportingPDF,
  isExportingExcel
}) {
  const [worksiteOptions, setWorksiteOptions] = useState([]);
  const [technologyListing, setTechnologyListing] = useState([]);

  const fetchTechnologies = async () => {
    try {
      const response = await get_technology_with_out_pagination();
      if (response?.status === "success") {
        // Transform data into the desired format with label and value
        const transformedData = response.data.data?.map((item) => ({
          label: item?.TechnologiesName,
          value: item?.TechnologiesTypeId
        }));

        // Set the transformed data to the state
        setTechnologyListing(transformedData || []);
      } else {
        setTechnologyListing([]);
      }
    } catch (error) {
      console.error('Error fetching technologies:', error);
      setTechnologyListing([]);
    }
  };


  useEffect(() => {
    fetchSites();
    fetchTechnologies()
  }, []);



  const fetchSites = async () => {
    try {
      const response = await get_worksite_with_out_pagination();
      if (response?.status === 'success') {
        const filtered = response.data.data
          .filter(item => item?.ParentWorksiteCode !== null)
          .map(item => ({ label: item.worksiteName, value: item.WorksiteID }));
        setWorksiteOptions(filtered);
      }
    } catch (error) {
      console.error('Failed to load worksites', error);
    }
  };


  const formik = useFormik({
    initialValues: {
      project: '',
      worksite: '',
      technology: '',
      month: '', year: ''
    },
    // onSubmit: values => {
    //   searchFilter(values);
    // },
  });

  const resetFilter = () => {
    formik.resetForm();

    on_change_value(1)
    on_page_count_update(25)

    searchFilter({
      project: '',
      worksite: '', technology: '', month: '', year: ''
    });
  };
  const breadcrumbs = ["Reports", tableTitle];
  return (
    <div className="common-search-filter-container">
      <div className="common-search-filter-sub-container">
        <div className="common-search-header">
          <div className="common-search-left">
            <div className="common-table-title">{tableTitle}</div>
            <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
          </div>
          <div className="common-export-buttons-container">
            <ActionButtonWithIcon
              label="Export PDF"
              onClick={onExportPDF}
              icon={Icons.PdfIcon}
              backgroundColor="#ffffff"
              hoverColor="#fef2f2"
              labelColor="#000000"
              borderColor="#e5e7eb"
              iconColor="#dc2626"
              loading={isExportingPDF}
            />

            <ActionButtonWithIcon
              label="Export Excel"
              onClick={onExportExcel}
              icon={Icons.ExcelIcon}
              backgroundColor="#ffffff"
              hoverColor="#f0fdf4"
              labelColor="#000000"
              borderColor="#e5e7eb"
              iconColor="#16a34a"
              loading={isExportingExcel}
            />
          </div>
        </div>

        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <CustomTextFieldWithIcon
              id="project_name"
              name="project_name"
              placeholder="Search by Project"
              value={formik.values.project_name}
              onChange={formik.handleChange}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <CustomSelectDropdown
              name="worksite"
              placeholder="Select Worksite"
              options={worksiteOptions}
              value={worksiteOptions.find(opt => opt.value === formik.values.worksite) || ''}
              onChange={opt => formik.setFieldValue('worksite', opt?.value || '')}
              onBlur={formik.handleBlur}
              isMulti={false}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <CustomTextFieldWithIcon
              id="schedule_code"
              name="schedule_code"
              placeholder="Search by Schedule Code"
              value={formik.values.schedule_code}
              onChange={formik.handleChange}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <CustomSelectDropdown
              name="technology"
              placeholder="Select Technology"
              options={technologyListing}
              value={technologyListing.find((tech) => tech.value === formik.values.technology) || ""}
              onChange={(selectedOption) => {
                formik.setFieldValue("technology", selectedOption ? selectedOption.value : "");
              }}
              onBlur={formik.handleBlur}

              isDisabled={false}
              isMulti={false} // Single select
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            {/* <CustomSelectDropdown
              name="month"
              placeholder="Select Month"
              options={monthOptions}
              value={monthOptions.find(opt => opt.value === formik.values.month) || ''}
              onChange={opt => formik.setFieldValue('month', opt?.value || '')}
              onBlur={formik.handleBlur}
              isMulti={false}
              width="200px"
            /> */}

            <CustomSelectDropdown
              name="month"
              placeholder="Select Month"
              options={monthOptions}
              value={monthOptions.find(opt => opt.value === formik.values.month || '')}
              onChange={opt => formik.setFieldValue('month', opt?.value || '')}
              onBlur={formik.handleBlur}
              isMulti={false}
              isClearable={false}
              width="200px"
            />
            {/* <CustomSelectDropdown
              name="project"
              placeholder="Select Project"
              options={projectOptions}
              value={projectOptions.find(opt => opt.value === formik.values.project) || ''}
              onChange={opt => formik.setFieldValue('project', opt?.value || '')}
              onBlur={formik.handleBlur}
              isMulti={false}
              width="200px"
            /> */}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomSelectDropdown
              name="year"
              placeholder="Select Year"
              options={yearOptions}
              value={yearOptions.find(opt => opt.value === formik.values.year || '')}
              onChange={opt => formik.setFieldValue('year', opt?.value || '')}
              onBlur={formik.handleBlur}
              isMulti={false}
              isClearable={false}
              width="200px"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ActionButton
                  onClick={() => {
                    on_change_value(1)
                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                  }}
                  btnDisable={false}
                  label="Search"
                  btnType="primary"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <ActionButton
                  onClick={resetFilter}
                  label="Reset"
                  btnType="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default WorksiteReportFilter;